// @ts-nocheck
import firebase from './_firebase';

export default class Api {

  constructor() {

    this.db = firebase.firestore();

    this.algolia = {};

    this.response = ({ empty, size=0, docs }) => ({
      size: size,
      empty: empty,
      docs: docs,
    });

    this.data = ({ empty, size=0, docs }) => ({
      size: size, empty: empty,
      data: docs.map(a => ({ id: a.id, ...a.data()})),
    });

  }

  collection = (name) => this.db.collection(name);

  document = async (collection,cid) => {

    const record = this.collection(collection).doc(cid);

    return await record.get().then(a => a.data());

  }

  authenticate = async ({ email_address, password }) => {

    const users = this.collection('customers');

    const error = 'Invalid Email Address or Password';

    const db_users = users.where('email', '==', email_address);

    const { docs, empty } = await db_users.get().then(ref => ref);

    const has_error = (empty) || (docs[0].data().password !== password);

    return (!!has_error) ? { error } : { id: docs[0].id, ...docs[0].data() };

  }

  signup = async ({name, email_address, password}) => {

    const users = this.collection('customers');

    const data = { name, password, email: email_address };

    const db_users = users.where('email', '==', email_address);

    const { empty } = await db_users.get().then(response => response);

    if (!empty) return { error: 'The Email Address is already registered'}

    const { error, id } = await users.add(data).catch(e => ({error: e.message}));

    return { error, id, name };

  }

  update_session = async (data={}) => {

    if (!data.fid) return null;

    const session = this.db.doc(`sessions/${data.fid}`);

    return await session.set({...data},{merge:true}).catch(e => ({error:e.message}));

  }

  log_session = async (session_data) => {

    const sessions = this.collection('sessions');

    const query = sessions.where('cid', '==', session_data.cid);

    const { empty, data } = await query.get().then(a => this.data(a));

    if (!empty) return { error: `Data for ${data[0].cid} already exists` };

    return await sessions.add(session_data).catch(e => ({error: e.message}));

  }

  fetch = async (collection,field,value,query=true) => {

    const db = this.collection(collection).where('active','==',true);

    const request = (!query) ? db.doc(value) : db.where(field,'==',value);

    const response = await ((field==='all') ? db.get() : request.get());

    return (!query) ? response : this.response(response);

  };

  update_cart = async (user,values=[]) => {

    const cart = values;

    const cart_count = values.length;

    const user_cart = this.db.doc(`sessions/${user}`);

    return await user_cart.set({ cart, cart_count },{merge:true});

  }

  fetch_cart = async (user) => {

    const user_cart = this.db.doc(`sessions/${user}`);

    return await user_cart.get().catch(e => e);

  }

  checkout = async (values) => {

    const request = this.collection('checkout').add(values);

    const data = await request.then(ref => ref);

    return data.id;

  }

  payment = async (id) => {

    const database = firebase.database().ref(`ipay/payments`);

    const data = await database.once('value').then(snapshot => snapshot.val()) || {};

    const payments = Object.keys(data).reduce((out, key) => {
      out.push({ id: key, ...data[key] });
      return out;
    }, []);

    return payments.filter(a => a.order_id===id)[0] || { error: true };

  }

  index_payload = (objectID,a) => {
    const { images, title, handle, tags, attributes, category, collection, vendor } = a;
    return {objectID,title,handle,tags,attributes,category,collection,vendor,image:images[0]};
  }

  index_exists = (i,id) => i.getObject(id).catch(a=>({empty:true}));

  index_data = async (INDEX_NAME, KEY, INDEX_DATA = []) => {

    /*const index = this.algolia.initIndex(INDEX_NAME);

    const indexes = INDEX_DATA.map(async (a) => {

      const objectID = a[KEY];

      const payload = this.index_payload(objectID,a);

      const { empty } = await this.index_exists(index,objectID);

      //console.log('payload :', {payload,empty});

      return (!empty) ? null : await index.saveObject(payload);

    });

    return await Promise.all(indexes);*/

  }

  search = async (query='') => {

    if (query==='') return [];

    const match = (product_property='') => {
      return product_property.toLowerCase().includes(query.toLowerCase());
    }

    const { data=[] } = await this.fetch('products','all','').then(a=>this.data(a));

    const filtered_data =  data.map(product => {
      const { category, description, handle, title } = product;
      const is_positive_match = (match(category) || match(description) || match(handle) || match(title));
      return (!!is_positive_match) ? {...product, image: product.images[0] || ''} : null;
    });

    return filtered_data.filter(a => a!==null) || [];

    //const index = this.algolia.initIndex('products');

    //return await index.search({query}).then(a => a.hits);

  }

}
